/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type {
  SearchPageBody,
  MappedSearchPartTypes,
  SearchPageBodyRecordsElement,
} from '../../interface';

export function getSearchVariables(
  searchPageBody?: Array<SearchPageBody[0] | MappedSearchPartTypes>
): {
  searchOriginalPartTypeId: string;
  searchProductRepositoryId: string;
  searchResultPosition: string;
} {
  const records = searchPageBody?.find(
    (entry): entry is SearchPageBodyRecordsElement => 'records' in entry
  )?.records;
  let searchOriginalPartTypeId = '';
  let searchProductRepositoryId = '';
  let searchResultPosition = '';

  records?.forEach(
    (
      {
        searchResultPosition: position,
        propertyMap: { originalPartTypeId, P_ProductRepositoryId },
      },
      index: number
    ) => {
      const nonExistentValue = 'N/A'; // this is a business requirement to use N/A for null or empty values

      const separator = records.length - 1 !== index ? '|' : '';
      searchOriginalPartTypeId += (originalPartTypeId?.[0] || nonExistentValue) + separator;
      searchProductRepositoryId += (P_ProductRepositoryId[0] || nonExistentValue) + separator;
      searchResultPosition += `${position || nonExistentValue} ${separator}`;
    }
  );
  return {
    searchOriginalPartTypeId,
    searchProductRepositoryId,
    searchResultPosition,
  };
}
